
import React, { useRef } from "react";
import Slider from "react-slick";

export default function HomeBanner() {
const sliderRef1 = useRef(null); 
const sliderRef2 = useRef(null); 
const slideCount = 5;

const syncTextSlider = (oldIndex, newIndex) => {
  const textSlider = sliderRef1.current;
  if (!textSlider) return;

  const nextIndex = (oldIndex + 1) % slideCount;
  const previousIndex = (oldIndex - 1 + slideCount) % slideCount;

  if (newIndex === nextIndex) {
    textSlider.slickNext();
    return;
  }

  if (newIndex === previousIndex) {
    textSlider.slickPrev();
    return;
  }

  textSlider.slickGoTo(newIndex, true);
};

const CircleSettings = {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 1400,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "0px",
  autoplay: false,
  rtl: false, 
};

const ContentSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 1400,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  rtl: false, 
  beforeChange: syncTextSlider,
};


  return (
    <>
    <div className="home-banner">
        <div className="container">
            <div className="row justify-content-end position-relative">  
                <div className="col-lg-9 col-md-10">
                    <Slider {...ContentSettings} ref={sliderRef2} className="banner-slider">
                        <div className="testi-content">
                            <img src="/image/banner-4.webp" className="img-responsive" alt="banner" width="1308" height="626" loading="eager" fetchpriority="high" decoding="async"/>
                        </div>

                        <div className="testi-content">
                            <img src="/image/banner-5.webp" className="img-responsive" alt="banner" width="1308" height="626" loading="lazy" decoding="async"/>
                        </div>

                        <div className="testi-content">
                            <img src="/image/banner-1.webp" className="img-responsive" alt="banner" width="1308" height="626" loading="lazy" decoding="async"/>
                        </div>

                        <div className="testi-content">
                            <img src="/image/banner-2.webp" className="img-responsive" alt="banner" width="1308" height="626" loading="lazy" decoding="async"/>
                        </div>

                        <div className="testi-content">
                            <img src="/image/banner-3.webp" className="img-responsive" alt="banner" width="1308" height="626" loading="lazy" decoding="async"/>
                        </div>
                    </Slider>
                </div>

                <div className="banner-textbox">
                    <span className="heading">Inspiring</span>
                    <div className="banner-textslider">
                        <Slider {...CircleSettings} ref={sliderRef1}> 

                            <div>
                                <span className="slide-title">Values</span>
                            </div>

                            <div>
                                <span className="slide-title">Excellence</span>
                            </div>
 
                            <div>
                                <span className="slide-title">Heritage</span>
                            </div>

                            <div>
                                <span className="slide-title">Minds</span>
                            </div>

                            <div>
                                <span className="slide-title">Innovation</span>
                            </div>
                        </Slider>
                    </div>
                </div>

            </div>
        </div> 

        <p className="site-latlong">26.8619, 81.0304</p>
    </div>
    </>
  )
}
